var alignment_rtlignore_default = {
  "alignLeft": "tzhVf",
  "textWrapNowrap": "eoBBD",
  "alignRight": "cL6-Z",
  "alignCenter": "_6UPT2",
  "sizeFullWidth": "bUIxG",
  "renderedInTable": "Wl1ff",
  "sizeOriginal": "_9iUqy",
  "sizeContent": "_3biEa",
  "sizeSmall": "GnvHD",
  "sizeSmallCenter": "cvE1X",
  "flex": "_7i4v-",
  "LEFT": "zuK8D",
  "CENTER": "FzAZ9",
  "RIGHT": "tOOa1",
  "AUTO": "rRHk4",
  "JUSTIFY": "_7rPww"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
